<template>
    <div>136887777</div>
</template>
<script>
export default {
    data(){
        return{
            
        }
    },
    props:{
        phone:{
            type:String,
            default:""
        }
    },
    activated(){

    },
    deactivated(){

    },
    methods:{

    }
    
}
</script>